(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/hooks/assets/javascripts/use-games-from-contentlist.js') >= 0) return;  svs.modules.push('/components/casino-react/hooks/assets/javascripts/use-games-from-contentlist.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const normalizeCardData = svs.components.casino_react.common.utils.normalizeCardData;
const CardType = svs.components.casino_react.common.constants.CardType;
const useGamesFromContentList = listId => {
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    games = _useState2[0],
    setGames = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    totalGamesCount = _useState4[0],
    setTotalGamesCount = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  const _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  const fetchCategoryGames = useCallback(async categoryListId => {
    if (!categoryListId) {
      setError('Missing list id');
      return;
    }
    setIsLoading(true);
    setError(null);
    const useLegacyJupiterApi = !svs.core.detect.feature('ft-use-cms-api-client-lb');
    if (useLegacyJupiterApi) {
      try {
        const res = await svs.core.jupiterFetch.get("content/2/listfilter?listId=".concat(categoryListId, "&onlyName=true&routesDomain=spela&count=5000&channel=").concat(svs.core.data.capabilities.channel));
        const jsonRes = await res.json();
        if (jsonRes.result) {
          const normalizedResponse = jsonRes.result.map(game => normalizeCardData(game, CardType.GAME));
          setGames(normalizedResponse);
          setTotalGamesCount(jsonRes.totalCount);
        } else {
          setGames([]);
          setTotalGamesCount(0);
        }
      } catch (e) {
        setError(e);
        setGames([]);
        setTotalGamesCount(0);
      } finally {
        setIsLoading(false);
      }
      return;
    }

    try {
      const client = svs.content.shared.getCmsClient();
      const response = await client.v1.content.listFilter({
        listIds: categoryListId,
        count: 5000,
        include: 'name',
        channels: svs.core.data.capabilities.channel
      });
      const normalizedResponse = response.result.map(game => normalizeCardData(game, CardType.GAME));
      setGames(normalizedResponse);
      setTotalGamesCount(response.totalCount);
    } catch (e) {
      setError(e);
      setGames([]);
      setTotalGamesCount(0);
    } finally {
      setIsLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchCategoryGames(listId);
  }, [listId, fetchCategoryGames]);
  return {
    games,
    totalGamesCount,
    isLoading,
    error
  };
};
setGlobal('svs.components.casino_react.hooks.useGamesFromContentList', useGamesFromContentList);

 })(window);